import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ProviderResponse } from "src/app/types/provider-response";
import { environment } from "src/environments/environment";

import { ProviderSessionDataCreate } from "./provider-session.data";

@Injectable({
  providedIn: 'root'
})
export class ProviderSessionService {
  baseUrl = environment.baseUrl + '/api/gams/session';

  constructor(
    private httpClient: HttpClient
  ) { }

  create(payload: HttpParams | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>> = {}) {
    return this.httpClient.post<ProviderResponse<ProviderSessionDataCreate>>(`${this.baseUrl}/create`, payload);
  }

  updateIsActiveAsFalse(payload: HttpParams | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>> = {}) {
    return this.httpClient.post<ProviderResponse<Record<string, never>>>(`${this.baseUrl}/update-is-active-as-false`, payload);
  }

  updatePushToken(pushToken: string, pushPlatform: string) {
    return this.httpClient.post<ProviderResponse<Record<string, never>>>(`${this.baseUrl}/update-push-token`, {
      pushToken,
      pushPlatform,
    });
  }
}
